import { get } from './utils';
export function getMessage(messages, term, args = {}, { emptyOnMissingTerm = false } = {}) {
    var _a;
    const path = String(term);
    let message = get(messages, path);
    if (message === undefined)
        message = emptyOnMissingTerm ? '' : `[${path}]`;
    if (typeof message === 'string')
        return message;
    // POEditor supports plural and single forms of the same term.
    // If the message is an object with the "one" and "other" properties,
    // then we resolve which form to return based on the "count" param.
    if (message.one || message.other) {
        const pluralMessage = message;
        const { count } = args;
        if (count === undefined || count === null)
            return pluralMessage.other;
        const num = Number.parseInt(`${count}`, 10);
        if (num === 1)
            return (_a = pluralMessage.one) !== null && _a !== void 0 ? _a : pluralMessage.other;
        return pluralMessage.other;
    }
    return emptyOnMissingTerm ? '' : `[${path}: ${JSON.stringify(message)}]`;
}
export const replaceArguments = (message, args) => Object.keys(args).reduce((msg, arg) => {
    var _a, _b;
    let msgArgs = msg.split(`{{${arg}}}`);
    if (msgArgs.length === 1)
        msgArgs = msg.split(`{${arg}}`);
    return msgArgs.join((_b = (_a = args[arg]) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '');
}, message);
//# sourceMappingURL=format.js.map